import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Cookies from 'js-cookie';
import './Sidebar.css'

export default function Sidebar(props) {
  const location = useLocation();
  const isCandidateActive = location.pathname.includes('/candidate');
  const isuserActive = location.pathname.includes('/user')
  const isHrmsActive = location.pathname.includes('/hrms')
  const isDashboard = location.pathname === '/' || location.pathname.includes('/dashboard');
  const isRemarks = location.pathname.includes('/remarks')
  const isManagement = location.pathname.includes('/management')
  const isResumekerala = /^\/kerala-admission(\/|$)/.test(location.pathname);
  const isResume = /^\/resume(\/|$)/.test(location.pathname) && !isResumekerala;
  const isDirect = location.pathname.includes('/direct')
  const isAstro = location.pathname.includes('/management')
  // const isResume = location.pathname.includes('/resume')
  const isJotHelp =location.pathname.includes('/jot-help')
  const isJot = location.pathname.includes('/jot') && !isJotHelp && !location.pathname.includes('/jot-user')
  const isJotUser = location.pathname.includes('/jot-user') && !isJotHelp 
  const isadmission = location.pathname.includes('/admission')
  const isJapaneseAdmission = location.pathname.includes('/japanese-admission')
  const isIsraelactive = location.pathname.includes('/israel')
  const sidebarClass = props.isOpen ? "sidebar open" : "sidebar";
  let role = Cookies.get("role");


  const navigate = useNavigate()
  const handleSubMenuClick = (path) => {
    navigate(path)
  }


  return (

    <div className={`sidebar-bg d-flex flex-column ${sidebarClass}`}>
      <ul>
        {(role === 'admin' || role === 'administrator' || role === "staff") && (
          <li className={isDashboard ? 'active' : ''}>
            <Link to='/dashboard'><i className='fas fa-home px-2'></i><span>Dashboard</span></Link>
          </li>)}

        {role === 'admin' ?
          <li className={isIsraelactive ? 'active' : ''}>
            <Link to='/israel'><i className='fa fa-yen-sign px-2'></i><span>Israel</span></Link>
          </li> : ''}

        {(role === 'admin' || role === "staff") && (
          <li className={isCandidateActive ? 'active' : ''}>
            <Link to='/candidate'><i className='fa fa-user-plus px-2'></i><span>Candidates (Master Data)</span></Link>
          </li>)}

        {(role === 'admin' || role === 'administrator') && (
          <li className={`text-nowrap ${isadmission ? 'active' : ''}`}>
            <Link to='/admission'><i class="fas fa-id-card px-2"></i><span>Admission (Singapore)</span></Link>
          </li>)}

        {(role === 'admin') && (
          <>

            {/* <li className={`text-nowrap ${isJapaneseAdmission ? 'active' : ''}`}>
              <Link to='/japanese-admission'><i class="fas fa-file-signature px-2"></i><span>Astro Academy (Chennai)</span></Link>
            </li> */}
            <li className={`text-nowrap ${isJot ? 'active' : ''}`}>
              <Link to='/jot'><i class="fas fa-file-signature px-2"></i><span>JOT</span></Link>
            </li>
              <li className={`text-nowrap ${isJotHelp ? 'active' : ''}`}>
              <Link to='/jot-help'><i class="fas fa-file-signature px-2"></i><span>JOT Help</span></Link>
            </li>
             <li className={`text-nowrap ${isJotUser ? 'active' : ''}`}>
              <Link to='/jot-user'><i class="fas fa-file-signature px-2"></i><span>JOT User</span></Link>
            </li>
            <li className={isuserActive ? 'active' : ''}>
              <Link to='/user'><i className='fa fa-user px-2'></i><span>Users</span></Link>
            </li>
            <li className={`text-nowrap ${isRemarks ? 'active' : ''}`}>
              <Link to='/remarks'><i className='fa fa-handshake px-2'></i><span>Placement/Release</span></Link>
            </li>
            <li className={isHrmsActive ? 'active' : ''} onClick={() => handleSubMenuClick("/hrms")}>
              <Link><i className='fa fa-user px-2'></i><span>HRMS</span></Link>
            </li>
          </>
        )}
        {role === 'hrms' && (
          <li className={isHrmsActive ? 'active' : ''} onClick={() => handleSubMenuClick("/hrms")}>
            <Link><i className='fa fa-user px-2'></i><span>HRMS</span></Link>
          </li>
        )}
        {(role === 'hr') && (
          <li className={`text-nowrap ${isResume ? 'active' : ''}`}>
            <Link to='/resume'><i className='fa fa-handshake px-2'></i><span>Astro Academy (Chennai)</span></Link>
          </li>
        )}
        {(role === 'admin' || role === 'intermediate' || role =="management" ) && (
          <li className={`text-nowrap ${isResume ? 'active' : ''}`}>
            <Link to='/resume'><i className='fa fa-handshake px-2'></i><span>Astro Academy (Chennai)</span></Link>
          </li>
        )}
        {(role === 'admin' || role === 'kerala_intermediate' || role === 'kerala_hr') && (
          <li className={`text-nowrap ${isResumekerala ? 'active' : ''}`}>
            <Link to='/kerala-admission'><i className='fa fa-handshake px-2'></i><span>Astro Academy (Kerala)</span></Link>
          </li>
        )}
        {/* {(role === 'hrms') && (
          <li className={`text-nowrap ${isAstro ? 'active' : ''}`}>
            <Link to='/management'><i className='fa fa-handshake px-2'></i><span>Astro Academy (Chennai)</span></Link>
          </li>
        )} */}



        {role === 'manager' && (
          <>

            <li className={isRemarks ? 'active' : ''}>
              <Link to='/remarks'><i className='fa fa-users px-2'></i><span>Placement/Release</span></Link>
            </li>

          </>
        )}
        {role === "intermediate" && (<li className={isDirect ? 'active' : ''}>
          <Link to='/direct'><i className='fa fa-university px-2'></i><span>Direct</span></Link>
        </li>
        )}
    
      {(role === 'management' || role === 'admin') && (
          <>

            <li className={isDirect ? 'active' : ''}>
              <Link to='/direct'><i className='fa fa-university px-2'></i><span>Direct</span></Link>
            </li>
          </>
        )}
        {/* {(role === 'management') && (
          <>
            <li className={isManagement ? 'active' : ''}>
              <Link to='/management'><i className='fa fa-university px-2'></i><span>Admission (Japan)</span></Link>
            </li>
            <li className={isDirect ? 'active' : ''}>
              <Link to='/direct'><i className='fa fa-university px-2'></i><span>Direct</span></Link>
            </li>
          </>
        )} */}


      </ul>

    </div >
  )
}
